export const lotoLucky = [
    {
        title: 'Lucky 5',
        description: 'Choisissez Toujours 5 Numéros',
        column: {
            number: [
                '5 [Numéros]',
                '4 [Numéros] + 1 [Numéros]',
                '3 [Numéros] + 2 [Numéros]',
                '4 [Numéros]',
                '3 [Numéros] + 1 [Numéros]',
                '2 [Numéros] + 2 [Numéros]',
                '3 [Numéros]',
                '2 [Numéros] + 1 [Numéros]',
                '1 [Numéros] + 2 [Numéros]',
                '2 [Numéros]',
            ],
            mise: '500',
            gains: [
                '100,000,000',
                '10,000,000',
                '10,000,000',
                '2,500,000',
                '250,000',
                '250,000',
                '100,000',
                '10,000',
                '10,000',
                '7,500',
            ],
        },
    },
    {
        title: 'Lucky 4',
        description: 'Choisissez Toujours 4 Numéros',
        column: {
            number: [
                '4 [Numéros]',
                '3 [Numéros] + 1 [Numéros]',
                '2 [Numéros] + 2 [Numéros]',
                '3 [Numéros]',
                '2 [Numéros] + 1 [Numéros]',
                '1 [Numéros] + 2 [Numéros]',
                '2 [Numéros]',
                '1 [Numéros] + 1 [Numéros]',
                '0 [Numéros] + 2 [Numéros]',
            ],
            mise: '500',
            gains: ['5,000,000', '1,000,000', '1,000,000', '175,000', '17,500', '17,500', '15,000', '1,500', '1,500'],
        },
    },
    {
        title: 'Lucky 3',
        description: 'Choisissez Toujours 3 Numéros',
        column: {
            number: [
                '3 [Numéros]',
                '2 [Numéros] + 1 [Numéros]',
                '1 [Numéros] + 2 [Numéros]',
                '2 [Numéros]',
                '1 [Numéros] + 1 [Numéros]',
                '0 [Numéros] + 2 [Numéros]',
            ],
            mise: '500',
            gains: ['2,000,000', '40,000', '40,000', '20,000', '1,000', '1,000'],
        },
    },
];

export const lottoNap = {
    header: [
        {
            title: 'game',
        },
        {
            title: 'description',
        },
        {
            title: 'multiplier',
        },
        {
            title: 'Example Stake',
        },
        {
            title: 'winning (Example)',
        },
    ],
    body: [
        {
            name: 'Nap2 (2sure)',
            description: 'Select 2 numbers; confident they will be among the 5 winning numbers drawn.',
            multiplier: 240,
            exampleStake: '[symbol]50',
            winningExample: '[symbol]12,000',
        },
        {
            name: 'Nap3 (3direct)',
            description: 'Select 3 numbers; confident they will be among the 5 winning numbers drawn.',
            multiplier: 2100,
            exampleStake: '[symbol]50',
            winningExample: '[symbol]105,000',
        },
        {
            name: 'Nap4 (Select 4 from 90)',
            description: 'Select 4 numbers from 90 options.',
            multiplier: 6000,
            exampleStake: '[symbol]50',
            winningExample: '[symbol]300,000',
        },
        {
            name: 'Nap5 (Select 5 from 90)',
            description: 'Select 5 numbers from 90 options.',
            multiplier: 44000,
            exampleStake: '[symbol]50',
            winningExample: '[symbol]2,200,000',
        },
    ],
};

export const lottoPermBet = {
    header: [
        {
            title: 'game',
        },
        {
            title: 'description',
        },
        {
            title: 'multiplier',
        },
        {
            title: 'Example Stake',
        },
        {
            title: 'winning (Example)',
        },
    ],
    body: [
        {
            name: 'Perm2',
            description:
                'Pick [pick] to [to] numbers, need at least [least] to win. Lines generated based on selections',
            desPick: 3,
            desTo: 10,
            desLeast: 2,
            multiplier: 240,
            exampleStake: '[symbol]5 per line',
            winningExample: 'If 2 numbers drop in 10 lines at [symbol]5: [symbol]1,200',
        },
        {
            name: 'Perm3',
            description:
                'Pick [pick] to [to] numbers, need at least [least] to win. Lines generated based on selections',
            desPick: 4,
            desTo: 10,
            desLeast: 3,
            multiplier: 2100,
            exampleStake: '[symbol]5 per line',
            winningExample: 'If 3 numbers drop in 10 lines at [symbol]5: [symbol]10,500',
        },
        {
            name: 'Perm4',
            description:
                'Pick [pick] to [to] numbers, need at least [least] to win. Lines generated based on selections',
            desPick: 5,
            desTo: 10,
            desLeast: 4,
            multiplier: 6000,
            exampleStake: '[symbol]10 per line',
            winningExample: 'If 5 numbers drop in 5 lines at [symbol]10: [symbol]300,000',
        },
        {
            name: 'Perm5',
            description:
                'Pick [pick] to [to] numbers, need at least [least] to win. Lines generated based on selections',
            desPick: 6,
            desTo: 10,
            desLeast: 5,
            multiplier: 44000,
            exampleStake: '[symbol]9 per line',
            winningExample: 'If 5 numbers drop in 6 lines at [symbol]9: [symbol]2,376,000',
        },
    ],
};

export const lottoPermLine = {
    header: [
        {
            title: 'Numbers Selected',
        },
        {
            title: 'Perm2 Lines',
        },
        {
            title: 'Perm3 Lines',
        },
        {
            title: 'Perm4 Lines',
        },
        {
            title: 'Perm5 Lines',
        },
    ],
    body: [
        {
            numbersSelected: 3,
            perm2Lines: 3,
            perm3Lines: '',
            perm4Lines: '',
            perm5Lines: '',
        },
        {
            numbersSelected: 4,
            perm2Lines: 6,
            perm3Lines: 4,
            perm4Lines: '',
            perm5Lines: '',
        },
        {
            numbersSelected: 5,
            perm2Lines: 10,
            perm3Lines: 10,
            perm4Lines: 5,
            perm5Lines: '',
        },
        {
            numbersSelected: 6,
            perm2Lines: 15,
            perm3Lines: 20,
            perm4Lines: 15,
            perm5Lines: 6,
        },
        {
            numbersSelected: 7,
            perm2Lines: 21,
            perm3Lines: 35,
            perm4Lines: 35,
            perm5Lines: 21,
        },
        {
            numbersSelected: 8,
            perm2Lines: 28,
            perm3Lines: 56,
            perm4Lines: 70,
            perm5Lines: 56,
        },
        {
            numbersSelected: 9,
            perm2Lines: 36,
            perm3Lines: 84,
            perm4Lines: 126,
            perm5Lines: 126,
        },
        {
            numbersSelected: 10,
            perm2Lines: 45,
            perm3Lines: 120,
            perm4Lines: 210,
            perm5Lines: 252,
        },
    ],
};

export const lottoInstant = {
    header: [
        {
            title: 'MATCH',
        },
        {
            title: 'PRIZE',
        },
    ],
    body: [
        {
            match: 6,
            prize: '[symbol]1,000,000',
        },
        {
            match: 5,
            prize: '[symbol]500,000',
        },
        {
            match: 4,
            prize: '[symbol]10,000',
        },
        {
            match: 3,
            prize: '[symbol]1,000',
        },
        {
            match: 2,
            prize: '[symbol]300',
        },
        {
            match: 1,
            prize: '[symbol]150',
        },
    ],
};
